import { render, staticRenderFns } from "./StatsIconContainer.vue?vue&type=template&id=d1367634&"
import script from "./StatsIconContainer.vue?vue&type=script&lang=js&"
export * from "./StatsIconContainer.vue?vue&type=script&lang=js&"
import style0 from "./StatsIconContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports